import React from 'react'

export const ExcelFileAsync = React.lazy(() => import('./excel-file'))
